import React, { useRef, useEffect, useState } from 'react';
import Header from '../components/Header';
import WorkshopStepCard from '../components/WorkshopStepCard';
import WorkshopForm from '../components/WorkshopForm';
import ContactFooter from '../components/ContactFooter';

const Workshops = () => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const [matchedHeight, setMatchedHeight] = useState(null);

  useEffect(() => {
      const resize = () => {
        const height1 = ref1.current?.offsetHeight || 0;
        const height2 = ref2.current?.offsetHeight || 0;
        const height3 = ref3.current?.offsetHeight || 0;
        const maxHeight = Math.max(height1, height2, height3);
        setMatchedHeight(maxHeight);
      };
  
      
    });

  const cardStyle = {
    maxWidth: '350px',
    textAlign: 'left',
    backgroundColor: 'rgb(15, 15, 26)',
    border: '1px solid rgba(99, 102, 241, 0.3)',
    borderRadius: '1rem',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
  };

  const imageStyle = {
    width: '100%',
    height: '160px',
    objectFit: 'cover',
    borderRadius: '0.5rem',
    borderBottomLeftRadius: '0rem',
    borderBottomRightRadius: '0rem',
    border: '1px solid rgb(51, 51, 51)',
    boxSizing: 'border-box',
  };

  return (
    <div style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh' }}>
      <Header />
      <main style={{ maxWidth: '1264px', margin: '0 auto', padding: '6rem 2rem 3rem' }}>
        <section style={{ textAlign: 'center', marginBottom: '3rem' }}>
          
          <h1 className="huge-title" style={{ marginBottom: '1rem' }}>
            Custom Workshops for Professionals
          </h1>
          <p className="subtitle" style={{
            fontSize: '1.25rem',
            color: '#a5b4fc',
            maxWidth: '800px',
            margin: '0 auto',
          }}>
            Upskill your team with expert-led quantum sessions. Tailored for any technical background and industry.
          </p>
        </section>

        <section style={{ marginBottom: '4rem' }}>
          <h2 className="title" style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            Our 3-Step Process
          </h2>

          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '2rem',
          }}>
            <div ref={ref1} style={{...cardStyle, height: matchedHeight}}>
              <img src="/define.JPG" alt="Define" style={imageStyle} />
              <WorkshopStepCard
                title="1. Define"
                subtitle="Shape Your Workshop"
                items={[
                  'Submit your focus areas via our form',
                  'Attend a 30-min exploratory call',
                  'Align expectations & timeline',
                ]}
              />
            </div>
            <div ref={ref2} style={{...cardStyle, height: matchedHeight}}>
              <img src="/design.JPG" alt="Design" style={imageStyle} />
              <WorkshopStepCard
                title="2. Design"
                subtitle="We Craft Your Experience"
                items={[
                  'Shared Drive set up for all materials',
                  'Weekly progress reports and feedback loop',
                  'Customized content based on your use case',
                ]}
              />
            </div>
            <div ref={ref3} style={{...cardStyle, height: matchedHeight}}>
              <img src="/deliver.JPG" alt="Deliver" style={imageStyle} />
              <WorkshopStepCard
                title="3. Deliver"
                subtitle="Workshop & Handoff"
                items={[
                  'Delivery online, hybrid, or on-site',
                  'Professional materials (slides, labs, certs)',
                  'Follow-up, summary, and feedback loop',
                ]}
              />
            </div>
          </div>
        </section>

        <section style={{ width: '100%', maxWidth: '700px', margin: '0 auto' }}>
          <WorkshopForm />
        </section>
      </main>
      <ContactFooter />
    </div>
  );
};

export default Workshops;
